import { grts } from "./reducerHelpers/dispatchProps"

const rts = {
  handleSet_clients: 'handleSet_clients',
  ...grts
}

export const homeInfoReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleSet_clients:
      return { ...state, clients: action.clients }

    default:
      return { ...state }
  }
}

export const homeInfoInitialState = (initState) => {
  return { ...initState }
};

export const homeInfoHandlers = (dispatch) => {
  return {
    handleSet_clients: (clients) => { dispatch({ type: rts.handleSet_clients, dispatch, clients }) },
  }
} 